export const SECURITY_PIPELINE_DISPLAY_NAME = "Security Pipeline";
